// motif-builder-birthstone.js
// パターン2（バースストーン必須）専用
//
//  - バースストーンの状態と、モチーフ上限/下限を RING ごとに分離
//  - 生成する要素の id に ring を含め、ID 衝突を解消
//  - ブラウザによる select 値の復元後に初期描画
//  - 誕生石の見出しに「？」を追加（モーダルは motif-builder-birthstone.liquid が出力）
//  - 動作確認が終わったら DEBUG を false にすること

(function () {

  var DEBUG = false;
  function log() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[motif]');
    console.log.apply(console, args);
  }

  function init() {
    log('init start');

    var productId     = window.__motifBuilderProductId;
    var mainVariantId = window.__motifBuilderMainVariantId;
    var motifLimitMap = window.__motifLimitByBirthstone || {};

    if (!productId) { log('ABORT: productId なし'); return; }

    var wrap = document.getElementById('motif-builder-' + productId);
    if (!wrap) { log('ABORT: wrap なし'); return; }

    var productFormEl = document.querySelector('product-form');
    if (!productFormEl) { log('ABORT: product-form なし'); return; }

    var submitBtn = productFormEl.querySelector('[type="submit"], [name="add"]');
    if (!submitBtn) { log('ABORT: submitBtn なし'); return; }

    var RINGS = ['single', 'a', 'b'];

    // ── バースストーン状態（RINGごと） ────────────────────
    var birthstoneProductHandle = window.__birthstoneProductHandle || null;
    var bs = {};   // ring -> { selectEl, container, selections: [] }

    RINGS.forEach(function (ring) {
      var el = document.getElementById('birthstone-select-' + ring + '-' + productId);
      if (!el) return;
      bs[ring] = {
        selectEl:   el,
        container:  document.getElementById('birthstone-type-selects-' + ring + '-' + productId),
        selections: []
      };
    });

    log('handle:', birthstoneProductHandle);
    log('limitMap:', motifLimitMap);
    log('bs rings:', Object.keys(bs));
    Object.keys(bs).forEach(function (r) {
      log('  ring', r, 'container:', !!bs[r].container, 'value:', bs[r].selectEl.value);
    });

    // ── キャッシュ ────────────────────────────────────────
    var priceCache   = {};
    var productCache = {};

    function esc(v) {
      var s = String(v == null ? '' : v);
      if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(s);
      return s.replace(/["\\\]\[]/g, '\\$&');
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.__moneyFormat);
      }
      var code = window.__cartCurrency || 'JPY';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'ja-JP', {
          style: 'currency',
          currency: code
        }).format(cents / 100);
      } catch (e) {
        return '¥' + Math.floor(cents / 100).toLocaleString('ja-JP');
      }
    }

    async function fetchProduct(handle) {
      if (productCache[handle]) return productCache[handle];
      try {
        var res = await fetch('/products/' + handle + '.js');
        if (!res.ok) { log('fetchProduct 失敗', handle, res.status); return null; }
        var data = await res.json();
        productCache[handle] = data;
        return data;
      } catch (e) {
        log('fetchProduct 例外', handle, e);
        return null;
      }
    }

    async function prefetchMotifs() {
      var btns    = wrap.querySelectorAll('.motif-builder__btn');
      var handles = [];
      btns.forEach(function (btn) {
        var h = btn.dataset.motifHandle;
        if (h && handles.indexOf(h) === -1) handles.push(h);
      });
      await Promise.all(handles.map(function (h) { return fetchProduct(h); }));
    }

    // ── 選択状態 ──────────────────────────────────────────
    var selections = { single: [], a: [], b: [] };

    // ── モチーフ上限/下限（RINGごと） ─────────────────────
    function resolveMotifRangeByValue(val) {
      var fallback = window.__motifBuilderMotifMax || 3;
      if (val !== null && Object.prototype.hasOwnProperty.call(motifLimitMap, val)) {
        return motifLimitMap[val];
      }
      return { min: fallback, max: fallback };
    }

    var ranges = {};
    RINGS.forEach(function (ring) {
      var val = bs[ring] ? bs[ring].selectEl.value : null;
      ranges[ring] = resolveMotifRangeByValue(val);
    });

    function rangeOf(ring) {
      return ranges[ring] || { min: 0, max: 0 };
    }

    async function applyMotifRange(ring, newRange) {
      var cur = rangeOf(ring);
      if (newRange.min === cur.min && newRange.max === cur.max) return;

      ranges[ring] = newRange;

      if (selections[ring].length > newRange.max) {
        selections[ring] = selections[ring].slice(0, newRange.max);
      }

      var btnsEl = document.getElementById(
        ring === 'single' ? 'motif-btns-' + productId : 'motif-btns-' + ring + '-' + productId
      );
      if (btnsEl) btnsEl.dataset.max = newRange.max;

      updateCount(ring);
      updateBtns(ring);
      await renderSelections(ring);
    }

    // ── バースストーン種類選択を動的生成 ──────────────────
    async function renderBirthstoneTypeSelects(ring, count) {
      log('renderBirthstoneTypeSelects', ring, 'count=', count);

      var st = bs[ring];
      if (!st) { log('  → 中断: bs[' + ring + '] なし'); return; }
      if (!st.container) { log('  → 中断: container なし'); return; }

      st.container.innerHTML = '';
      st.selections = [];

      var n = Math.min(parseInt(count, 10) || 0, 10);
      if (n <= 0) { log('  → 中断: n=0'); updateTotalPrice(); return; }
      if (!birthstoneProductHandle) { log('  → 中断: handle なし'); updateTotalPrice(); return; }

      var productData = await fetchProduct(birthstoneProductHandle);
      if (!productData) { log('  → 中断: 商品取得失敗'); return; }

      log('  → 生成:', n, '個 / variants:', productData.variants.length);

      for (var i = 0; i < n; i++) {
        st.selections.push(null);

        var itemWrap = document.createElement('div');
        itemWrap.className = 'product-form__input product-form__input--dropdown birthstone-type-select-wrap';

        var selectId = 'birthstone-type-' + ring + '-' + i + '-' + productId;

        var label = document.createElement('label');
        label.className = 'form__label';
        label.setAttribute('for', selectId);
        label.textContent = 'Birthstone ' + (i + 1);

        var selectWrap = document.createElement('div');
        selectWrap.className = 'select';

        var select = document.createElement('select');
        select.className     = 'select__select';
        select.id            = selectId;
        select.dataset.ring  = ring;
        select.dataset.index = i;

        var defaultOpt = document.createElement('option');
        defaultOpt.value = '';
        defaultOpt.textContent = '選択してください';
        select.appendChild(defaultOpt);

        productData.variants.forEach(function (variant) {
          var opt = document.createElement('option');
          opt.value = variant.id;
          opt.textContent = (variant.option1 || variant.title) + '　' + formatMoney(variant.price);
          opt.dataset.choiceLabel = variant.option1 || variant.title;
          priceCache[variant.id] = variant.price;
          select.appendChild(opt);
        });

        select.addEventListener('change', function () {
          var r   = this.dataset.ring;
          var idx = Number(this.dataset.index);
          var opt = this.options[this.selectedIndex];
          bs[r].selections[idx] = this.value
            ? { variantId: this.value, choiceLabel: opt.dataset.choiceLabel }
            : null;
          updateTotalPrice();
        });

        selectWrap.appendChild(select);
        itemWrap.appendChild(label);
        itemWrap.appendChild(selectWrap);
        st.container.appendChild(itemWrap);
      }

      log('  → 完了. children =', st.container.children.length);
      updateTotalPrice();
    }

    // ── 誕生石見出しの「？」 ──────────────────────────────
    //  option_help に target_motif = natural-stoneoption のエントリーがあると、
    //  liquid 側で HiddenOpener-motif-{handle}-{productId} が出力される。
    //  それがあるときだけ、各 RING の個数セレクトの見出しに「？」を1つ付ける。
    function createHelpButton(openerBtn) {
      var helpBtn = document.createElement('button');
      helpBtn.type      = 'button';
      helpBtn.className = 'option-help-trigger';
      helpBtn.setAttribute('aria-haspopup', 'dialog');
      helpBtn.setAttribute('aria-label', '詳細を見る');
      var helpIcon = document.createElement('span');
      helpIcon.setAttribute('aria-hidden', 'true');
      helpIcon.textContent = '？';
      helpBtn.appendChild(helpIcon);
      helpBtn.addEventListener('click', function (e) {
        e.preventDefault();   // label 内に置くため、select へのフォーカス移動を止める
        openerBtn.click();
      });
      return helpBtn;
    }

    function attachBirthstoneHelp() {
      if (!birthstoneProductHandle) return;

      var openerBtn = document.getElementById('HiddenOpener-motif-' + birthstoneProductHandle + '-' + productId);
      if (!openerBtn) { log('birthstone help: option_help エントリーなし'); return; }

      Object.keys(bs).forEach(function (ring) {
        var selectEl = bs[ring].selectEl;
        var labelEl  = document.querySelector('label[for="' + esc(selectEl.id) + '"]');

        if (labelEl) {
          if (labelEl.querySelector('.option-help-trigger')) return;  // 二重追加防止
          labelEl.appendChild(createHelpButton(openerBtn));
          log('birthstone help: label に追加', ring);
          return;
        }

        // label が見つからない場合：セレクトの直前に置く
        var anchor = selectEl.closest('.select') || selectEl;
        var prev   = anchor.previousElementSibling;
        if (prev && prev.classList.contains('birthstone-help-row')) return;
        var row = document.createElement('div');
        row.className = 'birthstone-help-row';
        row.appendChild(createHelpButton(openerBtn));
        anchor.parentNode.insertBefore(row, anchor);
        log('birthstone help: label なし → select 直前に追加', ring);
      });
    }

    // ── カウント更新 ──────────────────────────────────────
    function updateCount(ring) {
      var countEl = document.getElementById(
        ring === 'single' ? 'motif-count-' + productId : 'motif-count-' + ring + '-' + productId
      );
      if (!countEl) return;
      var r = rangeOf(ring);
      var rangeLabel = r.min === r.max ? String(r.max) : (r.min + '〜' + r.max);
      countEl.textContent = '（' + selections[ring].length + '/' + rangeLabel + '）';
    }

    // ── ボタン活性制御 ────────────────────────────────────
    function updateBtns(ring) {
      var btnsEl = document.getElementById(
        ring === 'single' ? 'motif-btns-' + productId : 'motif-btns-' + ring + '-' + productId
      );
      if (!btnsEl) return;

      var isFull   = selections[ring].length >= rangeOf(ring).max;
      var selected = selections[ring].map(function (s) { return s.handle; });

      btnsEl.querySelectorAll('.motif-builder__btn').forEach(function (btn) {
        var already = selected.indexOf(btn.dataset.motifHandle) !== -1;
        if (already || isFull) btn.classList.add('is-disabled');
        else btn.classList.remove('is-disabled');
      });
    }

    // ── 選択済みアイテム描画 ──────────────────────────────
    async function renderSelections(ring) {
      var selectionsEl = document.getElementById(
        ring === 'single' ? 'motif-selections-' + productId : 'motif-selections-' + ring + '-' + productId
      );
      if (!selectionsEl) return;

      var existing = selectionsEl.querySelectorAll('.motif-builder__selection-item');
      var current  = selections[ring].length;

      if (existing.length > current) {
        selectionsEl.innerHTML = '';
        for (var i = 0; i < current; i++) {
          await appendSelectionItem(ring, i, selectionsEl);
        }
      } else if (existing.length < current) {
        await appendSelectionItem(ring, current - 1, selectionsEl);
      }

      updateTotalPrice();
    }

    async function appendSelectionItem(ring, i, selectionsEl) {
      var sel  = selections[ring][i];
      var item = document.createElement('div');
      item.className      = 'motif-builder__selection-item';
      item.dataset.ring   = ring;
      item.dataset.handle = sel.handle;
      item.dataset.index  = i;

      var header = document.createElement('div');
      header.className = 'motif-builder__selection-header';

      var titleGroup = document.createElement('div');
      titleGroup.className = 'motif-builder__selection-title-group';

      var title = document.createElement('span');
      title.className   = 'motif-builder__selection-title';
      title.textContent = (i + 1) + 'つ目：' + sel.label;

      var helpBtn = document.createElement('button');
      helpBtn.type      = 'button';
      helpBtn.className = 'option-help-trigger';
      helpBtn.setAttribute('aria-haspopup', 'dialog');
      helpBtn.setAttribute('aria-label', '詳細を見る');
      var helpIcon = document.createElement('span');
      helpIcon.setAttribute('aria-hidden', 'true');
      helpIcon.textContent = '？';
      helpBtn.appendChild(helpIcon);

      var removeBtn = document.createElement('button');
      removeBtn.type           = 'button';
      removeBtn.className      = 'motif-builder__selection-remove';
      removeBtn.textContent    = '✕';
      removeBtn.dataset.ring   = ring;
      removeBtn.dataset.handle = sel.handle;
      removeBtn.dataset.index  = i;

      var openerBtn = document.getElementById('HiddenOpener-motif-' + sel.handle + '-' + productId);

      titleGroup.appendChild(title);
      if (openerBtn) {
        helpBtn.addEventListener('click', function () { openerBtn.click(); });
        titleGroup.appendChild(helpBtn);
      }
      header.appendChild(titleGroup);
      header.appendChild(removeBtn);
      item.appendChild(header);

      var subEl = document.createElement('div');
      subEl.className = 'motif-builder__sub-option';

      var productData = await fetchProduct(sel.handle);
      if (productData) {
        if (sel.isBirthstone) {
          var select = document.createElement('select');
          select.className      = 'motif-builder__sub-select';
          select.dataset.ring   = ring;
          select.dataset.handle = sel.handle;
          select.dataset.index  = i;

          var defaultOpt         = document.createElement('option');
          defaultOpt.value       = '';
          defaultOpt.textContent = '誕生石を選んでください';
          select.appendChild(defaultOpt);

          productData.variants.forEach(function (variant) {
            var opt                 = document.createElement('option');
            opt.value               = variant.id;
            opt.textContent         = (variant.option1 || variant.title) + '　' + formatMoney(variant.price);
            opt.dataset.choiceLabel = variant.option1 || variant.title;
            priceCache[variant.id]  = variant.price;
            select.appendChild(opt);
          });

          if (sel.subVariantId) select.value = sel.subVariantId;

          select.addEventListener('change', function () {
            var idx = Number(this.dataset.index);
            selections[this.dataset.ring][idx].subVariantId = this.value;
            updateTotalPrice();
          });

          subEl.appendChild(select);

        } else {
          var subBtns = document.createElement('div');
          subBtns.className = 'motif-builder__sub-btns';

          productData.variants.forEach(function (variant) {
            priceCache[variant.id] = variant.price;

            var btn = document.createElement('button');
            btn.type                = 'button';
            btn.className           = 'motif-builder__sub-btn';
            btn.dataset.ring        = ring;
            btn.dataset.handle      = sel.handle;
            btn.dataset.index       = i;
            btn.dataset.variantId   = variant.id;
            btn.dataset.choiceLabel = variant.option1 || variant.title;

            if (variant.featured_image) {
              var img = document.createElement('img');
              img.src = variant.featured_image.src;
              img.width  = 40;
              img.height = 40;
              img.style.borderRadius = '50%';
              img.style.objectFit    = 'cover';
              btn.appendChild(img);
            }

            var labelEl   = document.createElement('span');
            var labelText = variant.option1 || variant.title;
            if (labelText.indexOf('(') !== -1) {
              var parts = labelText.split('(');
              labelEl.textContent = parts[0].trim();
              labelEl.appendChild(document.createElement('br'));
              var subSpan = document.createElement('span');
              subSpan.style.fontSize = '0.9em';
              subSpan.textContent = '(' + parts[1];
              labelEl.appendChild(subSpan);
            } else {
              labelEl.textContent = labelText;
            }
            btn.appendChild(labelEl);

            var priceEl = document.createElement('span');
            priceEl.style.fontSize = '1rem';
            priceEl.style.color    = 'rgba(var(--color-foreground), 0.6)';
            priceEl.textContent    = formatMoney(variant.price);
            btn.appendChild(priceEl);

            if (sel.subVariantId == variant.id) btn.classList.add('is-selected');

            btn.addEventListener('click', function () {
              var idx = Number(this.dataset.index);
              this.closest('.motif-builder__sub-btns')
                  .querySelectorAll('.motif-builder__sub-btn')
                  .forEach(function (b) { b.classList.remove('is-selected'); });
              this.classList.add('is-selected');
              selections[this.dataset.ring][idx].subVariantId = this.dataset.variantId;
              updateTotalPrice();
            });

            subBtns.appendChild(btn);
          });

          if (!sel.subVariantId) {
            var firstBtn = subBtns.querySelector('.motif-builder__sub-btn');
            if (firstBtn) {
              firstBtn.classList.add('is-selected');
              selections[ring][i].subVariantId = firstBtn.dataset.variantId;
            }
          }

          subEl.appendChild(subBtns);
        }
      }

      item.appendChild(subEl);
      selectionsEl.appendChild(item);
    }

    // ── 合計価格 ──────────────────────────────────────────
    async function updateTotalPrice() {
      var total = 0;

      var variantInput = productFormEl.querySelector('form [name="id"]');
      var mainVariant  = variantInput ? variantInput.value : mainVariantId;
      if (mainVariant && priceCache[mainVariant] === undefined) {
        try {
          var res  = await fetch('/variants/' + mainVariant + '.js');
          var data = await res.json();
          priceCache[mainVariant] = data.price;
        } catch (e) {}
      }
      total += priceCache[mainVariant] || 0;

      RINGS.forEach(function (ring) {
        selections[ring].forEach(function (sel) {
          if (sel.subVariantId && priceCache[sel.subVariantId]) total += priceCache[sel.subVariantId];
        });
      });

      Object.keys(bs).forEach(function (ring) {
        bs[ring].selections.forEach(function (sel) {
          if (sel && sel.variantId && priceCache[sel.variantId]) total += priceCache[sel.variantId];
        });
      });

      var priceEl = document.querySelector('.price__regular .price-item--regular, .price__sale .price-item--sale');
      if (priceEl) priceEl.textContent = formatMoney(total);
    }

    // ── モチーフボタン ────────────────────────────────────
    wrap.addEventListener('click', async function (e) {
      var btn = e.target.closest('.motif-builder__btn');
      if (btn && !btn.classList.contains('is-disabled')) {
        var ring = btn.dataset.ring;
        if (selections[ring].length >= rangeOf(ring).max) return;

        selections[ring].push({
          handle:       btn.dataset.motifHandle,
          label:        (btn.dataset.motifLabel || '').replace('【オプション】', '').trim(),
          isBirthstone: btn.dataset.isBirthstone === 'true',
          subVariantId: null
        });

        updateCount(ring);
        updateBtns(ring);
        await renderSelections(ring);
        return;
      }

      var removeBtn = e.target.closest('.motif-builder__selection-remove');
      if (removeBtn) {
        var r   = removeBtn.dataset.ring;
        var idx = Number(removeBtn.dataset.index);
        selections[r].splice(idx, 1);
        updateCount(r);
        updateBtns(r);
        await renderSelections(r);
      }
    });

    // ── カート追加 ────────────────────────────────────────
    var isSubmitting = false;

    submitBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      handleAddToCart();
    }, true);

    var formEl = productFormEl.querySelector('form');
    if (formEl) {
      formEl.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleAddToCart();
      }, true);
    }

    async function handleAddToCart() {
      if (isSubmitting) return;

      var originalText = submitBtn.textContent.trim();
      var errors = [];

      RINGS.forEach(function (ring) {
        var btnsEl = document.getElementById(
          ring === 'single' ? 'motif-btns-' + productId : 'motif-btns-' + ring + '-' + productId
        );
        if (!btnsEl) return;

        var ringLabel = ring === 'single' ? '' : 'RING ' + ring.toUpperCase() + ' ';
        var r = rangeOf(ring);

        if (selections[ring].length < r.min || selections[ring].length > r.max) {
          var countEl = document.getElementById(
            ring === 'single' ? 'motif-count-' + productId : 'motif-count-' + ring + '-' + productId
          );
          if (countEl) countEl.style.color = 'red';
          var rangeLabel = r.min === r.max ? r.max + 'つ' : r.min + '〜' + r.max + 'つ';
          errors.push(ringLabel + 'モチーフを' + rangeLabel + '選んでください');
        }

        selections[ring].forEach(function (sel, idx) {
          if (!sel.subVariantId) {
            errors.push(ringLabel + (idx + 1) + 'つ目「' + sel.label + '」の詳細を選択してください');
          }
        });
      });

      Object.keys(bs).forEach(function (ring) {
        var prefix = ring === 'single' ? '' : 'RING ' + ring.toUpperCase() + ' ';
        var cnt = parseInt(bs[ring].selectEl.value, 10) || 0;
        for (var bi = 0; bi < cnt; bi++) {
          if (!bs[ring].selections[bi] || !bs[ring].selections[bi].variantId) {
            errors.push(prefix + (bi + 1) + '個目のバースストーンを選択してください');
          }
        }
      });

      if (errors.length > 0) { alert(errors.join('\n')); return; }

      isSubmitting          = true;
      submitBtn.disabled    = true;
      submitBtn.textContent = '追加中…';

      var variantInput = productFormEl.querySelector('form [name="id"]');
      var variantId    = variantInput ? variantInput.value : mainVariantId;
      var bundleId     = 'bundle_' + Date.now();
      var items        = [];

      var mainProps = { _bundle_id: bundleId, _is_main: 'true' };

      Object.keys(bs).forEach(function (ring) {
        var prefix = ring === 'single' ? '' : 'RING ' + ring.toUpperCase() + ' ';
        if (bs[ring].selectEl.value) {
          mainProps[prefix + 'バースストーン'] = bs[ring].selectEl.value + '個';
        }
        bs[ring].selections.forEach(function (sel, idx) {
          if (sel && sel.choiceLabel) {
            mainProps[prefix + (idx + 1) + '個目のバースストーン'] = sel.choiceLabel;
          }
        });
      });

      RINGS.forEach(function (ring) {
        selections[ring].forEach(function (sel, idx) {
          var prefix = ring === 'single' ? '' : 'RING ' + ring.toUpperCase() + ' ';
          mainProps[prefix + (idx + 1) + 'つ目'] = sel.label;
        });
      });

      items.push({ id: Number(variantId), quantity: 1, properties: mainProps });

      // custom-builder 連携
      var customWrap = document.getElementById('custom-builder-' + productId);
      if (customWrap) {
        var toggleLabels = {};
        customWrap.querySelectorAll('.custom-builder__opt-btn[data-type="toggle"]').forEach(function (btn) {
          var label = btn.dataset.label;
          if (!label) return;
          toggleLabels[label] = toggleLabels[label] || { optionIndex: btn.dataset.optionIndex };
        });
        Object.keys(toggleLabels).forEach(function (label) {
          var idx = toggleLabels[label].optionIndex;
          var selectedBtn = customWrap.querySelector(
            '.custom-builder__opt-btn[data-type="toggle"][data-label="' + esc(label) + '"].is-selected'
          );
          if (!selectedBtn) return;
          if (!selectedBtn.dataset.variantId) {
            mainProps[label] = 'なし';
          } else if (selectedBtn.dataset.hasInput === 'true') {
            var inputEl = document.getElementById('option-text-' + idx + '-' + productId);
            var text = inputEl ? inputEl.value.trim() : '';
            mainProps[label] = text ? 'あり「' + text + '」' : 'あり';
          } else {
            mainProps[label] = 'あり';
          }
        });

        customWrap.querySelectorAll('.custom-builder__select--paid').forEach(function (sel) {
          var label = sel.dataset.label;
          if (!label) return;
          var o = sel.options[sel.selectedIndex];
          mainProps[label] = o && sel.value ? o.dataset.choiceLabel : '選択なし';
        });

        customWrap.querySelectorAll('.custom-builder__opt-btn.is-selected[data-type="toggle"]').forEach(function (btn) {
          var vid = btn.dataset.variantId;
          if (!vid) return;
          var props = { _bundle_id: bundleId, _is_main: 'false' };
          if (btn.dataset.hasInput === 'true') {
            var inputEl = document.getElementById('option-text-' + btn.dataset.optionIndex + '-' + productId);
            var text = inputEl ? inputEl.value.trim() : '';
            if (text) {
              props['刻印内容'] = text;
              props[btn.dataset.label + '内容'] = text;
            }
          }
          items.push({ id: Number(vid), quantity: 1, properties: props });
        });

        customWrap.querySelectorAll('.custom-builder__select--paid').forEach(function (sel) {
          var vid = sel.value;
          if (!vid) return;
          var o = sel.options[sel.selectedIndex];
          items.push({
            id: Number(vid), quantity: 1,
            properties: {
              _bundle_id: bundleId, _is_main: 'false',
              _display_label:  sel.dataset.label,
              _display_choice: o ? o.dataset.choiceLabel : ''
            }
          });
        });
      }

      // モチーフ明細
      RINGS.forEach(function (ring) {
        selections[ring].forEach(function (sel, idx) {
          if (!sel.subVariantId) return;
          var prefix = ring === 'single' ? '' : 'RING ' + ring.toUpperCase() + ' ';

          var choiceLabel = '';
          if (sel.isBirthstone) {
            var selectEl = document.querySelector(
              '.motif-builder__sub-select[data-ring="' + esc(ring) + '"][data-handle="' + esc(sel.handle) + '"][data-index="' + idx + '"]'
            );
            if (selectEl) {
              var o = selectEl.options[selectEl.selectedIndex];
              choiceLabel = o ? (o.dataset.choiceLabel || '') : '';
            }
          } else {
            var subBtnEl = document.querySelector(
              '.motif-builder__sub-btn.is-selected[data-ring="' + esc(ring) + '"][data-handle="' + esc(sel.handle) + '"][data-index="' + idx + '"]'
            );
            choiceLabel = subBtnEl ? (subBtnEl.dataset.choiceLabel || '') : '';
          }

          items.push({
            id: Number(sel.subVariantId), quantity: 1,
            properties: {
              _bundle_id: bundleId, _is_main: 'false',
              _display_label:  prefix + sel.label,
              _display_choice: choiceLabel
            }
          });
        });
      });

      // バースストーン明細
      Object.keys(bs).forEach(function (ring) {
        var prefix = ring === 'single' ? '' : 'RING ' + ring.toUpperCase() + ' ';
        bs[ring].selections.forEach(function (sel, idx) {
          if (!sel || !sel.variantId) return;
          items.push({
            id: Number(sel.variantId), quantity: 1,
            properties: {
              _bundle_id: bundleId, _is_main: 'false',
              _display_label:  prefix + (idx + 1) + '個目のバースストーン',
              _display_choice: sel.choiceLabel || ''
            }
          });
        });
      });

      try {
        var res = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ items: items })
        });

        if (!res.ok) {
          var errData = await res.json().catch(function () { return {}; });
          throw new Error(errData.description || 'カートへの追加に失敗しました');
        }

        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('.cart-count-bubble span').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        });

        submitBtn.textContent = '追加しました ✓';
        setTimeout(function () {
          isSubmitting = false;
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }, 2000);

      } catch (err) {
        alert(err.message);
        isSubmitting = false;
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      }
    }

    // ── 変更を購読 ────────────────────────────────────────
    Object.keys(bs).forEach(function (ring) {
      bs[ring].selectEl.addEventListener('change', async function () {
        log('change', ring, this.value);
        await applyMotifRange(ring, resolveMotifRangeByValue(this.value));
        await renderBirthstoneTypeSelects(ring, this.value);
      });
    });

    // ── 初期描画（ブラウザのselect値復元を待つ） ──────────
    function initialRender() {
      log('initialRender');
      Object.keys(bs).forEach(function (ring) {
        var val = bs[ring].selectEl.value;
        applyMotifRange(ring, resolveMotifRangeByValue(val));
        renderBirthstoneTypeSelects(ring, val);
      });
      RINGS.forEach(function (ring) {
        updateCount(ring);
        updateBtns(ring);
      });
      updateTotalPrice();
      prefetchMotifs();
    }

    attachBirthstoneHelp();

    if (document.readyState === 'complete') {
      requestAnimationFrame(initialRender);
    } else {
      window.addEventListener('load', function () {
        requestAnimationFrame(initialRender);
      });
    }

    log('init done');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();